import {
  MainGridContainer,
  MainGridContainerItemLeft,
  MainGridContainerItemLeftBox,
  MainGridContainerItemRight, MainGridContainerItemRightBox,
  StyledTitle
} from "./styles";
import { Typography } from "@mui/material";
import Stepper from "../Stepper";
import React from "react";
import {useMatchMobile} from "hooks/useMatchMobile";


export const MiddleContent  = () => {
  const { isMatchMobile } = useMatchMobile();
  return (
    <MainGridContainer container>
      {!isMatchMobile && (
        <MainGridContainerItemLeft item md={12} lg={6}>
          <MainGridContainerItemLeftBox>
            <StyledTitle>Move from GloriaFood to Orders.co in seconds.</StyledTitle>
            <Typography
              sx={{
                mt: 2,
                color: "#4F4F4F",
                maxWidth: "420px",
                fontSize: "18px",
                lineHeight: "30px",
                fontFamily: "Poppins, sans-serif",
                textAlign: "left",
              }}
            >
              Import your restaurant details with a simple GloriaFood URL.
            </Typography>
          </MainGridContainerItemLeftBox>
        </MainGridContainerItemLeft>
      )}
      <MainGridContainerItemRight item lg={6} md={12} xs={12} sm={12}>
        <MainGridContainerItemRightBox>
          <Stepper />
        </MainGridContainerItemRightBox>
      </MainGridContainerItemRight>
    </MainGridContainer>
  )
}